import React from 'react';

export default function EmptyState({ message = 'No data found', icon = null, action = null }) {
  return (
    <div style={{ textAlign: 'center', padding: '3rem 1.5rem', color: 'var(--gray-500)' }}>
      <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem', opacity: 0.4 }}>{icon || '📋'}</div>
      <p style={{ margin: '0 0 1rem', fontSize: '0.9rem' }}>{message}</p>
      {action}
    </div>
  );
}